import { ReactComponent as TournamentCommentsSidebarSvg } from "../../assets/images/svgs/tournamentCommentsSidebar.svg";

const TournamentCommentsSidebarIcon = ({ className = "", ...props }) => {
  return (
    <TournamentCommentsSidebarSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default TournamentCommentsSidebarIcon;
